var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-mobile-nav__item" }, [
    _c(
      "a",
      _vm._b(
        {
          staticClass: "c-button c-mobile-nav__action",
          attrs: { href: _vm.computedHref },
        },
        "a",
        _vm.popupTriggerAttrs,
        false
      ),
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }